import React, { useEffect } from 'react';
import { string } from 'prop-types';
import { params, string as stringType, useDataModel } from '@thd-nucleus/data-sources';
import styles from './author-pod.scss';

const AuthorTitle = ({ articleGUID }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('author-title.ready'); }, []);

  const { data, loading, error } = useDataModel('article', {
    variables: { articleGUID }
  });

  if (!data || loading || error) {
    return null;
  }

  const title = data?.article?.title;

  return (
    <h1 data-testid="authorPodTitle" className="author-pod__title">
      {title}
    </h1>
  );
};

AuthorTitle.displayName = 'AuthorTitle';

AuthorTitle.dataModel = {
  article: params({ articleGUID: stringType().isRequired() }).shape({
    title: stringType(),
  }),
};

AuthorTitle.propTypes = {
  articleGUID: string.isRequired
};

export { AuthorTitle };
